/**
 * 存储命名空间 —— **全项目唯一的前缀来源**。
 *
 * localStorage 键、cookie 名、Cache 名全部从这里派生。散在七个文件里，改的时候必漏一个，
 * 而漏掉的那个恰恰最显眼。
 *
 * 这个文件同时被页面和 `src/sw.ts` import（injectManifest 会打包 SW，所以它能 import），
 * 于是不存在"SW 里那份硬编码的缓存名忘了跟着改"这类完全静默的 bug。
 *
 * ⚠️ 换 NS 会**静默丢掉用户的既有设置**（主题、语言、引导状态、应用锁）。
 * 真要换就在 PwaProvider 的 config 里填 legacyNamespace，迁移会在任何模块读键之前跑。
 */

import { createNamespace, createSafeStorage } from '@pwaship/core/storage'

export const NS = 'carsonos'

export const ns = createNamespace(NS)

/** 读不到、抛错、值损坏一律返回 fallback，绝不抛。隐私模式下写入会失败但不会白屏。 */
export const storage = createSafeStorage()
